import React, { useMemo } from 'react';
import _ from 'lodash';
import { useSelector } from 'react-redux';
import makeStyles from '@material-ui/core/styles/makeStyles';
import Grid from '@material-ui/core/Grid';
import classnames from 'classnames';

import LayoutContainer from '../components/LayoutContainer';
import VideoItem from '../../video-item/VideoItem';

import {
  selectOrientaion,
  selectVideoGridIds,
  selectParticipants,
  selectUserParticipant,
  selectVideoHideSelf,
  selectConfig,
} from '../../../../../selectors';

import {
  LAYOUT_TYPE_CONVERSATION,
  LAYOUT_ROTATE_LAND,
} from '../../../../../constants';

const useStyles = makeStyles(() => ({
  fullWidth: {
    width: '100%',
    flexWrap: 'nowrap',
  },
  focusWidth: {
    width: '75%',
  },
  trayWidth: {
    width: '25%',
    textAlign: 'center',
    transition: 'all 0.3s ease-in-out',
  },
  selfVideo: {
    right: '1%',
    bottom: '1%',
    width: '23%',
    position: 'absolute',
  },
  selftVideoOffset: {
    right: '25%',
    bottom: '1%',
    width: '23%',
    position: 'absolute',
  },
}));

const MobileConversationLayout = () => {
  const classes = useStyles();
  const orientation = useSelector(selectOrientaion);
  const videoGridIds = useSelector(selectVideoGridIds);
  const participants = useSelector(selectParticipants);
  const participantSelf = useSelector(selectUserParticipant);
  const videoHideSelf = useSelector(selectVideoHideSelf);
  const videoGridLimit = useSelector((state) => selectConfig(state, 'PORTAL_MIV_VIDEO_LIMIT')) || 7;

  const landscape = useMemo(() => orientation === LAYOUT_ROTATE_LAND, [orientation]);
  console.log(`Orientation:${orientation} landscape:${landscape}`);

  const participantIds = useMemo(() => {
    const filtered = videoGridIds.filter((id) => _.get(participants, [id, 'videoTrackMuted']) !== true);
    return [filtered.slice(0, 1), filtered.slice(1, Number(videoGridLimit))];
  }, [videoGridIds]);

  return (
    <LayoutContainer>
      <Grid container direction="row" className={classes.fullWidth}>
        { participantIds[0] && (
        <Grid
          item
          xs={12}
          className={
          classnames(
            participantIds[1].length > 0 && classes.focusWidth,
            participantIds[1].length === 0 && classes.fullWidth,
          )
        }
        >
          <VideoItem
            participantId={participantIds[0]}
            isMobileCrop
            layout={LAYOUT_TYPE_CONVERSATION}
          />
        </Grid>
        )}
        { participantIds[1].length > 0 && (
        <Grid item xs={3} direction="column" classname={classes.trayWidth}>
          {participantIds[1].map((id) => (
            <Grid
              item
              key={id}
            >
              <VideoItem
                participantId={id}
                isMobileCrop
                layout={LAYOUT_TYPE_CONVERSATION}
              />
            </Grid>
          ))}
        </Grid>
        )}
      </Grid>
      { !videoHideSelf && (
      <div
        className={
          classnames(
            participantIds[1].length > 0 && classes.selftVideoOffset,
            participantIds[1].length === 0 && classes.selfVideo,
          )
        }
      >
        <VideoItem
          participantId={participantSelf.id}
          layout={LAYOUT_TYPE_CONVERSATION}
          isTrayItem
        />
      </div>
      )}
    </LayoutContainer>
  );
};

export default MobileConversationLayout;
